const initVideoControls = (root = document) => {
  if (!root) return;
  const rootEl = typeof root === 'string' ? document.querySelector(root) : root;
  if (!rootEl) return;

  const MOBILE_BREAKPOINT = 1024;

  const getCurrentVideo = (container) => {
    const mobileVideo = container.querySelector('.media--mobile');
    const desktopVideo = container.querySelector('.media--desktop');

    if (mobileVideo && desktopVideo) {
      const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
      return isMobile ? mobileVideo : desktopVideo;
    }
    return container.querySelector('video');
  };

  rootEl.querySelectorAll('.media__custom-controls').forEach((controlsWrapper) => {
    const mediaContainer = controlsWrapper.closest('.media__container');
    if (!mediaContainer) return;
    const videos = mediaContainer.querySelectorAll('video');
    if (videos.length <= 0) return;

    videos.forEach((video) => {
      if (!video.paused) {
        mediaContainer.classList.add('playing');
      } else {
        mediaContainer.classList.remove('playing');
      }

      if (video.muted) {
        mediaContainer.classList.add('muted');
      } else {
        mediaContainer.classList.remove('muted');
      }

      video.addEventListener('play', () => {
        mediaContainer.classList.add('playing');
      });

      video.addEventListener('pause', () => {
        mediaContainer.classList.remove('playing');
      });

      video.addEventListener('volumechange', () => {
        if (video.muted) {
          mediaContainer.classList.add('muted');
        } else {
          mediaContainer.classList.remove('muted');
        }
      });
    });

    window.addEventListener('resize', () => {
      videos.forEach((video) => {
        video.pause();
      });
    });

    const playPauseBtn = controlsWrapper.querySelector('.media__pause-controls');
    if (playPauseBtn) {
      playPauseBtn.addEventListener('click', () => {
        const video = getCurrentVideo(mediaContainer);
        if (!video) return;

        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });
    }

    const muteBtn = controlsWrapper.querySelector('.media__mute-controls');
    if (muteBtn) {
      muteBtn.addEventListener('click', () => {
        const video = getCurrentVideo(mediaContainer);
        if (!video) return;

        video.muted = !video.muted;
      });
    }
  });
};

export { initVideoControls };
